import React from 'react';
import styles from './styles.css';

const SubHeading = ({ text, children }) => (
  <>
    <h2>
      {text}
      {children}
    </h2>
    <style jsx>{styles}</style>
  </>
);

SubHeading.defaultProps = {
  text: ''
};

export default SubHeading;
